import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Menu } from 'semantic-ui-react';

import { ACCOUNT_PATH, BILLING_PATH, ORDER_HISTORY } from '../../../constants/paths/internal';

type Props = {
  isOnUserBillingInfoRoute: boolean;
  pathname: string;
};

const BillingPageHeader = ({ isOnUserBillingInfoRoute, pathname }: Props) => {
  return (
    <>
      <div className="billing-page__header">
        <h2>{isOnUserBillingInfoRoute ? 'User billing info' : 'Billing'}</h2>
        <Link to={isOnUserBillingInfoRoute ? BILLING_PATH : ACCOUNT_PATH}>
          <Button
            content={isOnUserBillingInfoRoute ? 'To billing plans' : 'To Settings'}
            circular
            basic
            size="tiny"
            icon={isOnUserBillingInfoRoute ? 'credit card outline' : 'settings'}
          />
        </Link>
      </div>
      {!isOnUserBillingInfoRoute && (
        <Menu pointing secondary>
          <Menu.Item name="Plans" active={pathname === BILLING_PATH} as={Link} to={BILLING_PATH} />
          <Menu.Item
            name="History"
            active={pathname === ORDER_HISTORY}
            as={Link}
            to={ORDER_HISTORY}
          />
        </Menu>
      )}
    </>
  );
};

export default React.memo(BillingPageHeader);
